// Generated by scripts/generate-public-surface.ts. Do not edit.

import type { GlobalValidator } from "../types";

import { createValidator } from "#stdnum-runtime";

const isin: GlobalValidator = createValidator("isin", 104);

export default isin;
export const compact = isin.compact;
export const format = isin.format;
export const validate = isin.validate;
export const generate = (): string =>
  isin.generate?.() ??
  (() => {
    throw new Error(
      "Validator isin cannot generate values",
    );
  })();
